// Setup checklist step definitions. Ids must match the step ids returned by
// GET /setup/progress (ForeplayServer services/setup/config.js).
//
//   section      section the step renders under on the Setup page
//   scope        'user' (each team member) or 'workspace' (once for the team)
//   product      product the step needs access to (see utils/productAccess);
//                incomplete steps for a locked product render locked and don't
//                count toward progress
//   weight       points toward the progress percent
//   requires     step ids that must be done before this step unlocks
//                (ignored when the required step's product is locked)
//   desktopOnly  step needs a desktop browser (extension, MCP)
export const SETUP_STEPS = [
  // Account
  { id: 'email_verified', section: 'account', scope: 'user', weight: 1 },
  { id: 'extension_installed', section: 'account', scope: 'user', product: 'library', weight: 1, desktopOnly: true },
  { id: 'teammate_invited', section: 'account', scope: 'workspace', weight: 1 },

  // Competitor ads & inspiration
  { id: 'spyder_track', section: 'research', scope: 'workspace', product: 'spyder', weight: 2 },
  { id: 'ad_rank_opened', section: 'research', scope: 'user', product: 'spyder', weight: 1, requires: ['spyder_track'] },
  { id: 'first_ad_saved', section: 'research', scope: 'user', product: 'library', weight: 1 },
  { id: 'board_shared', section: 'research', scope: 'user', product: 'library', weight: 1, requires: ['spyder_track'] },
  { id: 'discovery_search', section: 'research', scope: 'user', product: 'discovery', weight: 1 },
  { id: 'instagram_connected', section: 'research', scope: 'user', product: 'library', weight: 1 },

  // My ads
  { id: 'lens_connect', section: 'lens', scope: 'workspace', product: 'lens', weight: 2 },
  // Demo Lens walkthroughs: run on sample data, but only offered to accounts with Lens access
  { id: 'lens_top_performing', section: 'lens', scope: 'user', product: 'lens', weight: 1 },
  { id: 'lens_comparison', section: 'lens', scope: 'user', product: 'lens', weight: 1 },

  // Your AI
  { id: 'mcp_connected', section: 'mcp', scope: 'workspace', product: 'api', weight: 1, desktopOnly: true },
  { id: 'mcp_prompt', section: 'mcp', scope: 'workspace', product: 'api', weight: 1, desktopOnly: true }
]
